'use client'

import { CurrentRefinements } from '@components/CurrentRefinements'
import { FilterDrawer } from '@components/FilterDrawer'
import { InfiniteHitsWrapper } from '@components/InfiniteHitsWrapper'
import { SearchFacets } from '@components/SearchFacets'
import { SearchSortSubHeader } from '@components/SearchSortSubHeader'
import { Stack, useMediaQuery, useTheme } from '@hermes/web-components'
import { useIntercom } from '@hooks/useIntercom'
import { BodyContainer } from './SearchPage.styles'

export const SearchContainer = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  useIntercom({ hideLauncher: true })

  return (
    <BodyContainer maxWidth={'xl'}>
      <Stack direction="row" width="100%" sx={{ gap: { md: '20px' } }}>
        {isMobile ? (
          <FilterDrawer>
            <SearchFacets />
          </FilterDrawer>
        ) : (
          <Stack sx={{ maxWidth: '300px', minWidth: '300px' }}>
            <SearchFacets />
          </Stack>
        )}
        <Stack width={'100%'}>
          <SearchSortSubHeader />
          <CurrentRefinements />
          <InfiniteHitsWrapper />
        </Stack>
      </Stack>
    </BodyContainer>
  )
}
